const About = () =>{
     return(
        <div>
            <h1>Thiis is About us page</h1>
        </div>
     )
}

export default About;